import axios from "axios";

let apiUrl = process.env.REACT_APP_API_URL
let backendUrl = process.env.REACT_APP_BACKEND_API_URL
let dataUrl = process.env.REACT_APP_DATA_API_URL
let baseURL = process.env.REACT_APP_BASE_URL

// 创建axios实例
const service = axios.create({
  baseURL: '', // api的base_url
  timeout: 100000, // 请求超时时间
  headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
});

// 添加请求拦截器
service.interceptors.request.use(
  (request) => {
    let url = request.url
    if (url.indexOf(backendUrl) === -1 && url.indexOf(apiUrl) === -1  && url.indexOf(dataUrl) === -1 && url.indexOf(baseURL) === -1) {
      url = baseURL + url
    }
    request.url = url
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 拦截返回的数据res,通过返回值直接获取到服务器的数据
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
